var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.visible,"footer":null},on:{"cancel":_vm.close}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"alt":"example","src":_vm.urls}})])
}
var staticRenderFns = []

export { render, staticRenderFns }